import { render, staticRenderFns } from "./StringValue.vue?vue&type=template&id=ea45df3a&lang=pug&"
import script from "./StringValue.vue?vue&type=script&lang=ts&"
export * from "./StringValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports